<template>
    <div class="header">
        <div>
            <!-- Hearer  -->
            <!-- <div class="mt-4">
                <div class="card">
                    <div class="card-body">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item fw-bolder">Master Data</li>
                                <li class="breadcrumb-item">Budget Item</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div> -->
            <!-- Card  -->
            <div class="card mt-5">
                <div class="card-header">
                    <!-- Title -->
                    <h4 class="card-header-title">Budget Item</h4>
                    <!-- Button -->
                    <b-button v-if="isCreat" v-b-modal.modal-1 variant="primary" @click="isAdd = true">
                        <span class="fe fe-user-check mr-2"></span>
                        Create Budget Item
                    </b-button>
                </div>
                <div class="d-flex justify-content-end mb-3 mt-3 mr-3">
                    <label class="align-self-center mb-0 mr-3">Search</label>
                    <b-form-input v-model="body.search" class="w-auto" placeholder="Type Here..." @change="getList()">
                    </b-form-input>
                </div>
                <vue-good-table :line-numbers="true" :columns="columns" :rows="list.data" :sort-options="{
                    enabled: true,
                    }" :total-rows="list.totalItems" :pagination-options="{
                    enabled: true,
                    perPage: body.perPage,
                    }" style-class="vgt-table border-0 table" @on-page-change="onPageChange"
                    @on-per-page-change="onPageChange" @on-sort-change="onSortChange">
                    <!-- Loading -->
                    <div slot="emptystate" class="text-center font-size-14">
                        No data available
                    </div>
                    <!-- Custom Rows -->
                    <template slot="table-row" slot-scope="props">
                        <!-- Table Action -->
                        <span v-if="props.column.field == 'action'">
                            <b-button v-if="isUpdate" class="no-wrap btn-pill" variant="warning" size="sm"
                                @click="updateData(props.row)">
                                <span class="fe fe-edit"></span>
                            </b-button>
                            <b-button v-if="isDelete" class="no-wrap ml-2" variant="danger" style="margin-left: 5px" size="sm"
                                @click="deleteData(props.row.id)">
                                <span class="fe fe-trash-2"></span>
                            </b-button>
                        </span>
                    </template>
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="d-flex justify-content-end">
                            <div>
                                <b-pagination :value="1" :total-rows="list.totalItems" :per-page="body.pageSize"
                                    first-number last-number align="right" prev-class="prev-item" next-class="next-item"
                                    class="mr-3 mb-4 mt-0"
                                    @input=" (value) => props.pageChanged({ currentPage: value })">
                                </b-pagination>
                            </div>
                        </div>
                    </template>
                </vue-good-table>
            </div>

            <!-- Modal -->
            <b-modal id="modal-1" hide-footer title="Budget Item Form">
                <form @submit.prevent="saveAdd()" v-if="isAdd === true">
                    <div class="form-group">
                        <label>TT Account <span class="text-danger">*</span></label>
                        <v-select :options="listAccount.data" label="account" :reduce="(e) => e.id"
                            v-model="modalCreate.account_id" />
                    </div>
<!--                    <div class="form-group">
                        <label>TT Code <span class="text-danger">*</span></label>
                        <b-input-group :prepend="modalCreate.code" class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input id="inline-form-input-username" v-model="modalCreate.item"
                                @change="isNumber" />
                        </b-input-group>
                        &lt;!&ndash; <input type="text" class="form-control" > &ndash;&gt;
                    </div>-->
                    <div class="form-group">
                        <label>TT Budget Item <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="modalCreate.budget_item">
                    </div>
                    <div class="form-group">
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="submit"
                            v-if="isLoading == false">
                            Save
                        </button>
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button"
                            disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>

                <form @submit.prevent="saveUpdate()" v-else>
                    <div class="form-group">
                        <label>TT Account <span class="text-danger">*</span></label>
                        <v-select :options="listAccount.data" label="account" :reduce="(e) => e.id"
                            v-model="modalUpdate.account_id" />
                    </div>
<!--                    <div class="form-group">
                        <label>TT Code <span class="text-danger">*</span></label>
                        <b-input-group :prepend="modalUpdate.code" class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input id="inline-form-input-username" v-model="modalUpdate.item"
                                @change="isNumber" />
                        </b-input-group>
                        &lt;!&ndash; <input type="text" class="form-control" > &ndash;&gt;
                    </div>-->
                    <div class="form-group">
                        <label>TT Budget Item <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="modalUpdate.budget_item">
                    </div>
                    <div class="form-group">
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="submit"
                            v-if="isLoading == false">
                            Save
                        </button>
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button"
                            disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import axiosIns from "@/api/axios";
import budgetItem from '@/store/modules/masterData/budget-item';
    export default {
        name: "GentaGendis",
        computed: {
            list() {
                return this.$store.getters["budgetItem/listData"];
            },
            listAccount() {
                return this.$store.getters["ttAccount/listAccount"];
            },
        },
        data() {
            return {
              body: {
                  pageNumber: 1,
                  pageSize: 10,
                  search: "",
                  field: "",
                  order: ""
              },
              modalCreate: {
                  //code: "",
                  //item: "",
                  budget_item: "",
                  account_id: ""
              },
              modalUpdate: {
                  //code: "",
                  //item: "",
                  budget_item: "",
                  account_id: ""
              },
              id: "",
              isAdd: true,
              isLoading: false,
              columns: [{
                      label: "TT Account",
                      field: "account.account",
                      thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
                      tdClass: "no-wrap color-secondary align-middle",
                  },
                  /*{
                      label: "TT CODE",
                      field: "item",
                      thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
                      tdClass: "no-wrap color-secondary align-middle",
                  },*/
                  {
                      label: "TT budget item",
                      field: "budget_item",
                      thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
                      tdClass: "no-wrap color-secondary align-middle",
                  },
                  {
                      label: "Action",
                      field: "action",
                      sortable: false,
                      thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
                      tdClass: "no-wrap color-secondary align-middle",
                  },
              ],
              isRead: false,
              isCreat: false,
              isUpdate: false,
              isDelete: false
            };
        },

        mounted() {
          this.checkPermission();
          this.getList();
          this.getListAccount();
        },
        methods: {
          async checkPermission() {
            const roleName = localStorage.getItem("roles");
            const roleId = await axiosIns.get("/master-role/find-name?name=" + roleName);
            const menuId = await axiosIns.get("/master-menu/find-link?link=" + this.$route.path);
            const payloadPermission = {
              role_id: roleId.data.data[0]?.id || null,
              menu_id: menuId.data.data[0]?.id || null
            }
            const checkAuth = await axiosIns.post("/master-role/check-permission", payloadPermission);
            if(checkAuth.data.data?.authorization){
              this.isRead = checkAuth.data.data?.authorization.includes('read')
              this.isCreat = checkAuth.data.data?.authorization.includes('create')
              this.isUpdate = checkAuth.data.data?.authorization.includes('update')
              this.isDelete = checkAuth.data.data?.authorization.includes('delete')
            }
          },
            updateData(props) {
                this.$bvModal.show("modal-1");
                this.isAdd = false;
               // let arr = props.item.split(".")
                //console.log(arr);
                //this.modalUpdate.code = arr[0]
                //this.modalUpdate.item = arr[1]
                this.modalUpdate.account_id = props.account_id
                this.modalUpdate.budget_item = props.budget_item
                this.id = props.id;
            },

            getList() {
                this.$store.dispatch("budgetItem/GET_LIST_DATA", this.body);
            },
            getListAccount() {
                this.$store.dispatch("ttAccount/GET_LIST_ACCOUNT", {
                    pageNumber: 1,
                    pageSize: 1000,
                });
            },

            saveAdd() {
                /*if (this.modalCreate.account_id && this.modalCreate.budget_item && this.modalCreate.item) {*/
              if (this.modalCreate.account_id && this.modalCreate.budget_item) {
                  this.isLoading = true;
                  //this.modalCreate.item = `${this.modalCreate.code}.${this.modalCreate.item}`
                  this.$store
                      .dispatch("budgetItem/CREATE_DATA", this.modalCreate)
                      .then((resp) => {
                          this.$swal("Saved", "Your input has been saved", "success").then(
                              (resp) => {
                                  this.isLoading = false;
                                  (this.modalCreate = {
                                      account_id: '',
                                      budget_item: ''
                                  }),
                                  this.getList();
                                  this.$bvModal.hide("modal-1");
                              }
                          );
                      }).catch((resp) => {
                          this.$swal.mixin({
                                  toast: true,
                                  position: "top-end",
                                  showConfirmButton: false,
                                  timer: 3000,
                                  timerProgressBar: true,
                                  didOpen: (toast) => {
                                      toast.addEventListener("mouseenter", this.$swal.stopTimer);
                                      toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                                  }
                              })
                              .fire({
                                  icon: "error",
                                  title: resp.response.data.error
                              });
                          this.isLoading = false
                      });
              } else {
                  this.$swal.mixin({
                          toast: true,
                          position: "top-end",
                          showConfirmButton: false,
                          timer: 3000,
                          timerProgressBar: true,
                          didOpen: (toast) => {
                              toast.addEventListener("mouseenter", this.$swal.stopTimer);
                              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                          }
                      })
                      .fire({
                          icon: "error",
                          title: 'Please fill mandatory data first'
                      });
              }

            },

            async saveUpdate() {
              /*if (this.modalUpdate.account_id && this.modalUpdate.budget_item && this.modalUpdate.item) {*/

              if (this.modalUpdate.account_id && this.modalUpdate.budget_item) {
                /*let body = {
                  id: this.id,
                  body: {
                    account_id: this.modalUpdate.account_id,
                    budget_item: this.modalUpdate.budget_item
                  }
                };*/
                this.isLoading = true;
                const payloadBodys = {
                  account_id: this.modalUpdate.account_id,
                  budget_item: this.modalUpdate.budget_item,
                }
                try {
                  const resp = await axiosIns.put(`/budget-item/${this.id}`, payloadBodys);
                  this.$swal("Saved", "Your input has been saved", "success").then(
                      (resp) => {
                        this.isLoading = false;
                        (this.modalUpdate = {
                          code: '',
                          account_id: '',
                          budget_item: '',
                          item: ''
                        }),
                            this.getList();
                        this.$bvModal.hide("modal-1");
                      }
                  );
                } catch (error) {
                  if (axios.isAxiosError(error)) {
                    if (error.response) {
                      this.$swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                          toast.addEventListener("mouseenter", this.$swal.stopTimer);
                          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                        }
                      })
                          .fire({
                            icon: "error",
                            title: error?.response?.data?.error || null
                          });
                      this.isLoading = false
                    }
                  } else {
                    console.error('Unexpected error:', error);
                  }
                }
              } else {
                this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                  }
                })
                    .fire({
                      icon: "error",
                      title: 'Please fill mandatory data first'
                    });
              }
            },

            deleteData(id) {
                this.$swal({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#00D97E",
                    cancelButtonColor: "#E63757",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "Cancel",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$store
                            .dispatch("budgetItem/DELETE_DATA", id)
                            .then((resp) => {
                                this.getList();
                                this.$swal.mixin({
                                        toast: true,
                                        position: "top-end",
                                        showConfirmButton: false,
                                        timer: 3000,
                                        timerProgressBar: true,
                                        didOpen: (toast) => {
                                            toast.addEventListener("mouseenter", this.$swal
                                                .stopTimer);
                                            toast.addEventListener("mouseleave", this.$swal
                                                .resumeTimer);
                                        }
                                    })
                                    .fire({
                                        icon: "success",
                                        title: 'Selected data has been deleted'
                                    });
                            })
                            .catch((resp) => {
                                this.$swal("Error", "Error while delete data", "error");
                            });
                    }
                });
            },

            /*searchAccount(id) {
                axiosIns.get(`${axiosIns.defaults.baseURL}/account/${id}`).then((resp) => {
                    let data = resp.data.data
                    this.modalCreate.code = data.code
                    this.modalUpdate.code = data.code
                })
            },*/

            // filter
            filterPage() {},

            sorting() {
                this.getList();
            },

            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            // Pagination
            onPageChange(payload) {
                this.body.limit = payload.currentPerPage;
                this.body.page = payload.currentPage;
                this.getList();
            },
            onSortChange(params) {
              let sort1 = params[0].field;
              let sort2 = params[0].type;
              this.body.field = sort1
              if (sort2 === 'none') {
                this.body.order = ''
              } else {
                this.body.order = sort2
              }
              this.getList();
            },
        },
    };
</script>